import {useLocation, useNavigate, useParams} from "react-router";
import Navbar from "../components/Navbar/Navbar";
import {useTranslation} from "react-i18next";
import {mustache} from "../Helpers/functions";
import {Alert, Col, Container, Row} from "react-bootstrap";
import style from "../components/PaymentItems/Payment.module.css";
import Select from 'react-select';
import { useState } from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import postCreateCliqPayment from "../Api/Requests/post-create-cliq-payment";
import i18n from "../i18n";

const Cliq = () => {
    const location = useLocation();
    const dataLocation = location.state
    // const url = data.data.redirectTo
    const {t} = useTranslation();
    let {memberId, cartId, identification,paymentSecret} = useParams();
    const options = [
        { value: 'alias', label: t('cliq.alias') },
        { value: 'mobile', label: t('cliq.mobile') },
    ];
    const [selectedOption, setSelectedOption] = useState(options[0]);
    const [isPayDisabled, setIsPayDisabled] = useState(true);
    const [aliasDescMessage,setAliasDescMessage] = useState(t('cliq.aliasDesc'))
    const [pickedAliasType, setPickedAliasType] = useState('alias');
    const [isInvalidInput, setIsInvalidInput] = useState(false);
    const [inputValue, setInputValue] = useState(false);
    const [hasGeneralError, setHasGeneralError] = useState(false);
    const [loading, setLoading] = useState(false);
    

    const changeAliasType = (e) => {
        if(e.value == 'alias'){
            setAliasDescMessage(t('cliq.aliasDesc'));
            setPickedAliasType('alias');
            if(inputValue){
                setIsPayDisabled(false);
                setIsInvalidInput(false);
            }else{
                setIsPayDisabled(true);
                setIsInvalidInput(true);
            }
        }else{
            if(validateText(inputValue)){
                setIsPayDisabled(false);
                setIsInvalidInput(false);
            }else{
                setIsPayDisabled(true);
                setIsInvalidInput(true);
            }
            setAliasDescMessage(t('cliq.aliasMobileDesc'));
            setPickedAliasType('mobile');
        }
    }
    
    const validateInput = (e) => {
        setInputValue(e.target.value);
        if(pickedAliasType == 'mobile'){
            if(validateText(e.target.value)){
                setIsPayDisabled(false);
                setIsInvalidInput(false);
            }else{
                setIsPayDisabled(true);
                setIsInvalidInput(true);
            }
        }else{
            if(e.target.value){
                setIsPayDisabled(false);
                setIsInvalidInput(false);
            }else{
                setIsPayDisabled(true);
                setIsInvalidInput(true);
            }
        }
    }

    function validateText(text) {
        // Check if the text starts with "00962"
        if (text && text.startsWith("00962")) {
            // Get the remaining part of the text after "00962"
            const remainingText = text.slice(5);

            // Check if the remaining text starts with "79", "78", or "77"
            if (remainingText.startsWith("79") || remainingText.startsWith("78") || remainingText.startsWith("77")) {
                // Check if the total length of the text is 14
                if (text.length === 14) {
                    // Text matches all the rules
                    return true;
                } else {
                    // Text length is not 14
                    return false;
                }
            } else {
                // Does not start with "79", "78", or "77"
                return false;
            }
        } else {
            // Does not start with "00962"
            return false;
        }
    }
    
    var navigate = useNavigate();
    const initiatePayment = () => {
        resetError();
        setHasGeneralError(false);
        setLoading(true);
        setIsPayDisabled(true)
        const data = {
            memberId,
            cartId,
            identification,
            aliasType : pickedAliasType,
            value : inputValue,
            paymentSecret : paymentSecret
        }

        postCreateCliqPayment(data).then((response) => {
            if(response.data.result.data.Cliq.response.Code == 400001){
                showError()
                setLoading(false);
                setIsPayDisabled(false)
                if(pickedAliasType === 'alias'){
                    setAliasDescMessage(t('cliq.aliasDesc'));
                }else{
                    setAliasDescMessage(t('cliq.aliasMobileDesc'));
                }
            }else if(response.data.result.data.Cliq.response.Code == 500001 || response.data.result.data.Cliq.response.Code == 401000){
                setHasGeneralError(true);
                setLoading(false);
                setIsPayDisabled(false)
            }else{
                navigate(`/payment/screen/${paymentSecret}/${cartId}`);
                // navigate(`/cliq/steps/${memberId}/${cartId}/${identification}/${paymentSecret}`,{
                //     state: {
                //         cartId :dataLocation?.cartId,
                //         paymentSecret :paymentSecret
                //     }
                // })
            }
        }).catch((e) => {
            setLoading(false);
            setIsPayDisabled(false)
            setHasGeneralError(true);
        })
    }

    const showError = () => {
        setIsPayDisabled(true);
        setIsInvalidInput(true);
    }

    const resetError = () => {
        setIsPayDisabled(false);
        setIsInvalidInput(false);
    }

    return (<div  dir={i18n.language=='en'?'ltr':'rtl'} > <div className={`${style.blocked_background}`} id={'background-popup'}></div>
        <Container className={`sm-pad-zero `}>
            <Row className={`justify-content-center `}>
                <Col className={`${style.parent_container}`} lg={6} md={8} sm={10}>
                    <Navbar referral_url={''} loading={false} title={t('cliq.payUsingCliq')}subTitle={mustache(t('page.payment.subtitle'), {cartId: dataLocation?.cartId})} />
                    <div style={{marginTop:"10px" ,padding : "20px"}}>
                        <Alert key={'danger'} variant={'danger'} className="p-1" show={hasGeneralError}>
                            {t('cliq.error')}
                        </Alert>
                        <div className="content">
                            <div className="title">{t('cliq.step1.listDescHeader')}</div>
                            <div className="instructions">
                                <ol className={i18n.language=='en'?'list-align-start-ltr':'list-align-start-rtl'}>
                                    <li>{t('cliq.step1.listDescContent1')}</li>
                                    <li>{t('cliq.step1.listDescContent2')} "{t('cliq.step1.listDescContent3')}"</li>
                                    <li>{t('cliq.step1.listDescContent4')}</li>
                                    <li>{t('cliq.step1.listDescContent5')}</li>
                                </ol>
                            </div>
                        </div>
                        <Form className="mt-5">
                            <Form.Group className="mb-3" controlId="formBasicAliasType">
                                <Form.Label>{t('cliq.aliasType')}</Form.Label>
                                <Select isSearchable={false} defaultValue={selectedOption} onChange={changeAliasType} options={options} className="select-arrow-custom-color"/>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicAlias">
                                <Form.Label>{t('cliq.aliasName')}</Form.Label>
                                <Form.Control type="text" onInput={(e) => {validateInput(e)}} />
                                <Form.Text id="mobileNumberHint" className={(isInvalidInput) ? 'text-danger fw-bold' : 'text-muted'} style={{fontSize: "13px"}}>
                                    {aliasDescMessage.replace('countryCode','(00962)').replace('sample','(009627XXXXXXXX)')}
                                </Form.Text>
                            </Form.Group>
                            <Button variant="primary" type="button" onClick={() => {initiatePayment()}} disabled={isPayDisabled}>
                                {!loading && t('cliq.payNow') }
                                {loading && t('cliq.button.wait') }
                            </Button>
                        </Form>
                    </div>
                </Col>
            </Row>
        </Container>
    </div>)
}

export default Cliq